module.exports = __webpack_public_path__ + "img/modal-login-benefits.03719c0d.svg";